import React from 'react';
import { Controller } from 'react-hook-form';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

const Select = ({
  name,
  control,
  displayName,
  required,
  placeholder,
  options,
  errors,
  validate,
  disabled,
  onChange: onValueChange,
  children
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={{
        required: required ? `${displayName} is required` : null,
        validate: validate
      }}
      render={({ field }) => (
        <div className="relative">
          <select
            className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-sm text-zinc-900 outline outline-1 -outline-offset-1 outline-zinc-300 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-primary cursor-pointer"
            {...field}
            onChange={(e) => {
              field.onChange(e);
              if (onValueChange) onValueChange(e.target.value);
            }}
          >
            {children}
          </select>
          <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-zinc-500 pointer-events-none" />
        </div>
      )}
    />
  );
};

export default Select;
